import axios from "axios";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

const DeleteOrderModal = ({ order, setOrders }) => {
  const [show, setShow] = useState(false);
  const user = useSelector((state) => state.user);

  const handleDelete = (orderId, userId) => {
    axios
      .delete(
        `https://the-green-shop.herokuapp.com/api/orderDetail/deleteById/${orderId}/${userId}`
      )
      .then(() => {
        return axios.get(
          `https://the-green-shop.herokuapp.com/api/orderDetail/getAll/${user.id}`
        );
      })
      .then((res) => {
        setOrders(res.data);
        setShow(!show);
      })
      .catch((error) => console.error(error));
  };

  return (
    <>
      <button className="btn btn-danger" onClick={() => setShow(true)}>
        Delete
      </button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm delete order?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShow(false)}>
            Close
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              handleDelete(order.id, user.id);
            }}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteOrderModal;
